var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { css, keyframes } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
var modalAppearKeyframes = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"])));
var modalCloseKeyframes = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n"])));
var closeAnimation = /*#__PURE__*/css("animation:", modalCloseKeyframes, " 250ms forwards;");
var openAnimation = /*#__PURE__*/css("animation:250ms ease-in-out 1 ", modalAppearKeyframes, ";");
export var globalStyles = {
  name: "m16vok",
  styles: ".body-no-scroll{position:fixed;width:100%;height:100%;overflow:hidden;}"
};
var _ref = {
  name: "1ruxp1v",
  styles: "padding:20px;"
};
export var modal = function modal(appearance) {
  var animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var hasCloseAnimation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return /*#__PURE__*/css("display:flex;position:fixed;top:0;left:0;align-items:center;justify-content:center;height:100%;width:100%;background:rgba(0,0,0,0.64);z-index:", variables.global.layerModal, ";", media('>=tablet'), "{height:100vh;", appearance !== 'drawer' && _ref, "}", animated && openAnimation, ";", hasCloseAnimation && closeAnimation, ";");
};